import { render, staticRenderFns } from "./StayDurationInput.vue?vue&type=template&id=fb6b63cc"
import script from "./StayDurationInput.vue?vue&type=script&lang=ts"
export * from "./StayDurationInput.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports